import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ServicesService } from '../services/services.service';
import { environment } from '../../environments/environment';
import swal from 'sweetalert2';

@Component({
  selector: 'app-daily-health-checks',
  templateUrl: './daily-health-checks.component.html',
  styleUrls: ['./daily-health-checks.component.css']
})
export class DailyHealthChecksComponent implements OnInit {
  construction_id: any;
  routerPath: string = '';
  fields: any = [];
  maintenance_id: any;
  isListDataEmpty: boolean = true;
  public loading = false;
  isLoader: boolean = false;
  apiBaseUrl = environment.apiBaseUrl;
  apiUrl = environment.apiUrl;
  spinLoader = {
    filter: false,
    delete: []
  };
  isListData = true;
  listData: any = [];
  routepath: string = '';

  constructor(private activeroute: ActivatedRoute, private _services: ServicesService, private router: Router) {
    this.activeroute.queryParams.subscribe(params => {
      this.construction_id = params['construction_id']
      //console.log("**", this.construction_id)

      this.listData = [
        // {
        //   'id' :'1',
        //   'toilet_type': 1,
        //   'toilet_number': 22123,
        //   'toilet_grade': 2,
        //   'image_1': "/assets/img/1.jpg",
        //   'image_2': "/assets/img/2.jpg",
        //   'image_3': "/assets/img/3.jpg",
        //   'construction_id':  this.construction_id,
        //   'created_at': '2019-12-27 14:44:06',
        //   'updated_at': '2019-12-27 14:44:06'
        // }
      ]
    });
  }

  ngOnInit() {
    this.getPageRequest()
    this.fields = [
      {
        'field': 'toilet_type',
        'title': 'Toilet Type',
        'width': '15%',
        'code': true,
        'sort': true
      },
      {
        'field': 'toilet_number',
        'title': 'Toilet Number',
        'width': '20%',
        'code': true,
        'sort': true
      },
      {
        'field': 'toilet_grade',
        'title': 'Toilet Grade',
        'width': '10%',
        'code': true,
        'sort': true
      },
      {
        'field': 'construction_id',
        'title': 'Nearest Construction',
        'width': '10%',
        'code': true,
        'sort': true,
        'actions': [{
          content: '',
          icon: 'fa fa-search',
          class: 'btn btn-sm btn-info',
          function: (id: number) => this.goToConstruction(id)
        }]
      },
      {
        'field': 'created_at',
        'title': 'Created at',
        'width': '15%',
        'code': false,
        'sort': true
      },
      {
        'field': 'updated_at',
        'title': 'Updated at',
        'width': '15%',
        'code': false,
        'sort': true
      },
    ]

    this.routepath = this.apiUrl + "/get-health-checks-pdf?id=";
  }

  private goToConstruction(id: number) {
    this.router.navigate(['/construction-info'], {
      queryParams: { const_id: id }
    })
  }

  getPageRequest() {
    const token = localStorage.getItem('userToken');
    console.log("-----+-----", this.construction_id, token)
    this._services.getConstructionHealthCheck(this.construction_id, token).subscribe((results: any) => {
      this._services.checkToken(results.status);
      if (results.status == "200") {
        // results.healthchecks.forEach(element => {
        //   if(element.construction_id == this.construction_id){
        //     this.listData.push(element);

        //   }
        // });
        this.listData = results.healthchecks;
        console.log(this.listData);

        this.isListDataEmpty = false;
      }
    })
  }

  sortType: string = "";
  sortField: string = "";
  oldField: string;
  sortingData = {
    field: "",
    type: ""
  };

  sortBy(field, event) {
    this.spinLoader['filter'] = true;

    this.oldField = this.oldField != field ? this.oldField : field;
    if (typeof this.oldField !== "undefined") {
      document.getElementById("fa-" + this.oldField).classList.remove("fa-sort-up")
      document.getElementById("fa-" + this.oldField).classList.remove("fa-sort-down")
      document.getElementById("fa-" + this.oldField).classList.add("fa-sort-sort")
    }

    event.target.classList.add("fa");
    this.sortField = field;
    this.sortType = this.sortType == "desc" ? "asc" : "desc";
    switch (this.sortType) {
      case "desc":
        {
          event.target.cl
        }
    }
  }

  Show(branch) {
    this.router.navigateByUrl(`health-check-information?construction_id=${branch.construction_id}&type=${branch.toilet_type}&number=${branch.toilet_number}&grade=${branch.toilet_grade}&image_1=${branch.image_1}&image_2=${branch.image_2}&image_3=${branch.image_3}`)
  }
}
